<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MtPqAF/images/Cover.jpg?1688985130693" alt="This image is the cover for the book Welcome Back #2, Welcome Back"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Welcome Back #2, Welcome Back
      </h1>
      <p class="bookDescription body article font2">
        <p>As Tessa flies to America to continue hunting her target, Mali learns the ropes of being a soldier while the memories of hundreds of past lives weigh on her mind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Sebela, Claire Roe, Jonathan Brandon Sawyer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?80dcdb26